import {Injectable, OnDestroy} from "@angular/core";
import {BehaviorSubject, fromEvent, Subject, Subscription, timer} from "rxjs";
import {EnumFiltroDePedidos, PedidosService} from "../services/pedidos.service";
import {AutorizacaoService} from "../services/autorizacao.service";
import {ConstantsService} from "./ConstantsService";
import {TelaImprimirPedido} from "./TelaImprimirPedido";
import {ImpressaoService} from "../services/impressao.service";
import {EnumMomentoImprimirAuto} from "../../../server/lib/emun/EnumMomentoImprimirAuto";
import {GrupolojasService} from "../superadmin/services/grupolojas.service";
import {EnumOrigemPedido} from "../../../server/lib/emun/EnumOrigemPedido";
import {ArmazenamentoService} from "../services/armazenamento.service";
import {DeviceDetectorService} from "ngx-device-detector";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import { NfceService } from "../services/nfce.service";
import {ServidorImpressaoExecutorService} from "../services/servidor-impressao-executor.service";
import {SocketService} from "../services/socket.service";
import moment from "moment";
const segundosTimer = 30;

declare var $;

@Injectable()
export class MonitoradorPedidos extends TelaImprimirPedido{
  public temModuloFiscal = false;
  public novosPedidos = [];
  public pedidosConfirmados = [];
  public pedidosCanceladosCliente = [];
  public pedidosContestados = [];
  public pedidosContestadosVisualizados = {}
  public pedidosEnderecoAlterado = [];
  public pedidosErroIntegracao = [];
  public falhasImportacao = [];
  public resumoMesas: any = new BehaviorSubject<any>(null);  //
  public resumoPedidos: any = new BehaviorSubject<any>(null);  //
  public mesasComErros: any = new BehaviorSubject<any>(null);  //
  public resumoEstoque: any = new BehaviorSubject<any>(null);  //
  public  resumoMesas$ = this.resumoMesas.asObservable();
  public  resumoPedidos$ = this.resumoPedidos.asObservable();
  public  mesasComErros$ = this.mesasComErros.asObservable();
  public  resumoEstoque$ = this.resumoEstoque.asObservable();
  private pedidosGrupoAtualizados = new Subject<any>();
  public pedidosGrupoAtualizados$ = this.pedidosGrupoAtualizados.asObservable();
  private integracoesGrupoAtualizadas = new Subject<any>();
  public integracoesGrupoAtualizadas$ = this.integracoesGrupoAtualizadas.asObservable();
  public pedidos = [];
  tarefaAlerta;
  beep;
  timerPedidos;
  timerLoja;
  timerLojaKeeta;
  timerLoja99;
  ultimoPedido;
  origens = [];
  tocarAlerta;
  KEYALERTAIFRAME = 'alerta-iframe'
  KEYNOTIFICACOESCENTRALPEDIDOSDESLIGADAS = 'central-pedidos-notificacoes-desligadas'
  KEYQUANTIDADETOQUESALERTA = 'central-pedidos-quantidade-toques-alerta'
  quantidadeToquesAlerta = 0;
  opcoesQuantidadeToquesAlerta = [
    {texto: '1 toque', valor: 1},
    {texto: '3 toques', valor: 3},
    {texto: '5 toques', valor: 5},
    {texto: '10 toques', valor: 10},
    {texto: 'Até fechar o aviso', valor: 0}
  ];
  lojasIfood: any = [];
  lojasKeeta: any = [];
  lojas99Food: any = [];
  modoGarcom: boolean;
  modoGrupoLojas: boolean
  configImpressaoPorEmpresaId: any = {};
  notificacoesCentralPedidosDesligadas = false;
  pedidosMonitorarPagamento = []
  timerNFCe;
  avisos: any [];
  isMobile: boolean;
  private socketNovosPedidos: Subscription;
  private socketCancelamentoPedidoCliente: Subscription;
  private socketLojaStatus: Subscription;
  carregandoNovos = false;
  private errosIntegracaoConhecidos: any = {};
  private ultimaAtualizacaoErroIntegracao: string;
  private monitoramentoErroIntegracaoIniciado = false;
  private carregandoNFCe = false;
  private imprimirNfceAutomaticamente = false;
  private moduloFiscalSubscription: Subscription;
  private impressaoAutomaticaNfceSubscription: Subscription;
  private monitoramentoGrupoLojasIniciado = false;
  private carregandoConfigsImpressaoGrupoLojas: Promise<any>;
  private configsImpressaoGrupoLojasCarregadas = false;
  private toquesRestantesAlerta = 0;
  constructor(  protected pedidosService: PedidosService, private autorizacaoService: AutorizacaoService,
                private     grupolojasService: GrupolojasService, protected http: HttpClient,
                private router: Router,  private servidorImpresaoExecutor: ServidorImpressaoExecutorService,
                private constantsService: ConstantsService, impressao: ImpressaoService,
                protected nfeService: NfceService,     private socketService: SocketService,
                private armazenamentoService: ArmazenamentoService,
                private detectorDevice: DeviceDetectorService) {
    super(impressao, pedidosService, nfeService)
    let usuario = this.autorizacaoService.getUser();
    this.modoGarcom = usuario && usuario.garcom
    this.isMobile = this.detectorDevice.isMobile();
    this.tocarAlerta =  !this.inIframe() && !this.modoGarcom && !this.isMobile;
    this.resumoMesas.next ({ totalNovo: 0, mesas: []})
    this.constantsService.empresa$.subscribe( (empresa: any) => {
       if(!empresa) return;
       this.empresa = empresa;
       this.atualizeMonitoramentoNFCe();
    })

    try{
      if(this.armazenamentoService.carregue(this.KEYALERTAIFRAME, false) === '1')
        this.tocarAlerta =  !this.modoGarcom;
    }catch(e){
      console.error(e)
    }

    try{
      this.notificacoesCentralPedidosDesligadas =
        this.armazenamentoService.carregue(this.KEYNOTIFICACOESCENTRALPEDIDOSDESLIGADAS, false) === '1';
    }catch(e){
      console.error(e)
    }

    try{
      const quantidadeSalva = Number(this.armazenamentoService.carregue(this.KEYQUANTIDADETOQUESALERTA, false));

      if(this.opcoesQuantidadeToquesAlerta.some((opcao: any) => opcao.valor === quantidadeSalva))
        this.quantidadeToquesAlerta = quantidadeSalva;
    }catch(e){
      console.error(e)
    }


    this.configureSockets();
  }

  autalizeStatusIfood(){
    const requisicao: any = this.modoGrupoLojas
      ? this.grupolojasService.listeStatusIfood()
      : this.http.get('/ifood/lojas/status', {}).toPromise();

    requisicao.then((resposta: any) => {
        this.lojasIfood = resposta || [];
        this.notifiqueIntegracoesGrupoAtualizadas();
    })

    if(this.modoGrupoLojas)
      this.grupolojasService.executePollingIfood().catch((err: any) => console.error(err));
  }

  autalizeStatus99Food(){
    const requisicao: any = this.modoGrupoLojas
      ? this.grupolojasService.listeStatus99Food()
      : this.http.get('/99food/lojas/status', {}).toPromise();

    requisicao.then((lojas: any) => {
      const lojasAtualizadas = lojas || [];

      if(this.modoGrupoLojas || lojasAtualizadas.length)
        this.lojas99Food = lojasAtualizadas;

      this.notifiqueIntegracoesGrupoAtualizadas();
    })
  }

  configureSockets(){
    this.socketLojaStatus = this.socketService.on('loja99food_atualizada').subscribe(async (loja: any) => {
      console.log('[SOCKET] loja_atualizada', loja);

      const index = this.lojas99Food.findIndex((item: any) => item.id === loja.id);

      this.lojas99Food.splice(index, 1, loja);

    });

    if(!this.socketNovosPedidos){
      this.socketNovosPedidos = this.socketService.on('novoPedido').subscribe(async (data: any) => {
        console.log('[SOCKET] novoPedido', data);

        if(this.monitorarNovosPedidos())
          this.carregueNovosPedidos();
      });
    }

    if(!this.socketCancelamentoPedidoCliente){
      this.socketCancelamentoPedidoCliente = this.socketService.on('pedido_cancelado_cliente').subscribe(async (data: any) => {
        console.log('[SOCKET] pedido_cancelado_cliente', data);

        if(!this.monitorarNovosPedidos()) return;

        if(this.chegouCancelamentoPedidoCliente(data)){
          if(this.modoGrupoLojas) {
            await this.carregueConfigsImpressaoGrupoLojas();
            this.apliqueConfigsImpressaoGrupoPedidos([data]);
          }

          if(this.centralPedidosEstaDesligada()) return;

          await this.imprimaCancelamentoPedidoNaoPago(data);
          if(this.tocarAlerta)
            this.inicieAlerta();
        }
      });
    }

  }

  autalizeStatusKeeta(){
    const requisicao: any = this.modoGrupoLojas
      ? this.grupolojasService.listeStatusKeeta()
      : this.http.get('/keeta/lojas/status', {}).toPromise();

    requisicao.then((lojas: any) => {
      const lojasAtualizadas = lojas || [];

      if(this.modoGrupoLojas || lojasAtualizadas.length)
        this.lojasKeeta = lojasAtualizadas;

      this.notifiqueIntegracoesGrupoAtualizadas();
    });
  }

  private notifiqueIntegracoesGrupoAtualizadas(){
    if(!this.modoGrupoLojas) return;

    this.integracoesGrupoAtualizadas.next({
      ifood: this.lojasIfood,
      food99: this.lojas99Food,
      keeta: this.lojasKeeta
    });
  }

  sincronizeLojaKeeta(loja: any){
    loja.keetaLoja = true;

    this.http.get('/keeta/lojas/basicinfo/atualize', {}).toPromise().then((resposta: any) => {

    })
  }

  async inicieMonitoramentoGrupoLojas(){
    if(!this.modoGrupoLojas) {
      this.pareMonitoramento();
      this.pareMonitoramentoIntegracoes();
      this.pareAlerta();
      this.fecheModalAlerta();
      this.limpePedidosMonitorados();
      this.limpeDadosGrupoLojas();
    }

    this.modoGrupoLojas = true;
    if(this.monitoramentoGrupoLojasIniciado) return;

    this.monitoramentoGrupoLojasIniciado = true;
    if(this.centralPedidosEstaDesligada()) {
      this.pareMonitoramento();
      this.pareMonitoramentoIntegracoes();
      this.pareAlerta();
      this.fecheModalAlerta();
      return;
    }

    await this.carregueConfigsImpressaoGrupoLojas();
    await this.inicieMonitoramento();
  }

  inicieMonitoramentoLoja(){
    if(this.modoGrupoLojas) {
      this.pareMonitoramento();
      this.pareMonitoramentoIntegracoes();
      this.pareAlerta();
      this.fecheModalAlerta();
      this.modoGrupoLojas = false;
      this.monitoramentoGrupoLojasIniciado = false;
      this.limpePedidosMonitorados();
      this.limpeDadosGrupoLojas();
    }

    this.inicieMonitoramento();
  }

  pareMonitoramentoGrupoLojas(){
    if(!this.modoGrupoLojas) return;

    this.pareMonitoramento();
    this.pareMonitoramentoIntegracoes();
    this.pareAlerta();
    this.fecheModalAlerta();
    this.modoGrupoLojas = false;
    this.monitoramentoGrupoLojasIniciado = false;
    this.limpePedidosMonitorados();
    this.limpeDadosGrupoLojas();
  }

 async inicieMonitoramento() {
    if(this.centralPedidosEstaDesligada()) {
      this.pareMonitoramento();
      this.pareMonitoramentoIntegracoes();
      this.pareAlerta();
      this.fecheModalAlerta();
      return;
    }

    if(this.modoGrupoLojas) {
      this.inicieMonitoramentoLojasIfood();
      this.inicieMonitoramentoLojasKeeta();
      this.inicieMonitoramentoLojas99Food();
    } else {
      if(this.empresa?.integracoesIfood?.length) this.inicieMonitoramentoLojasIfood();
      if(this.empresa?.integracoesKeeta?.length) this.inicieMonitoramentoLojasKeeta();
      if(this.empresa?.integracoes99Food?.length) this.inicieMonitoramentoLojas99Food();
    }

    this.configureMonitoramentoNFCe();

    if(!this.monitorarNovosPedidos() || this.timerPedidos)
      return;

    try{
      if(this.temServidorImpressoAssociadoAImpressora())
        await this.servidorImpresaoExecutor.inicieServidor( );
    } catch (er){
      console.error(er)
    }

    this.carregueMonitorePedidos();
  }

  temServidorImpressoAssociadoAImpressora(){
    if(this.modoGrupoLojas || !this.empresa?.configImpressao ) return false;

    const impressoras = this.empresa.configImpressao.impressoras || [];
    return impressoras.find((impressora: any) => impressora.servidorImpressao) != null
  }



  carregueMonitorePedidos(){
    if(this.centralPedidosEstaDesligada()) return;

    this.beep = document.getElementById("beep");
    console.log('iniciar monitoramente pedidos')
    if( this.beep && (this.empresa || this.modoGrupoLojas)){
      this.beep.load();
      this.inicieMonitoramentoPedidos();
    } else {
      console.log('beep não carregou tentar de novo em 1s')
      setTimeout( () => { this.carregueMonitorePedidos()}, 1000);
    }
  }

  toogleTocarIframe(){

    if(this.tocarAlerta || this.modoGrupoLojas){
      this.inicieMonitoramento()
    } else {
      this.pareMonitoramento();
    }

    if(!this.tocarAlerta) {
      this.pareAlerta();
      this.fecheModalAlerta();
    }

    this.armazenamentoService.salveSemExpirar(this.KEYALERTAIFRAME, this.tocarAlerta ? '1' : '0')
  }

  monitorarNovosPedidos(){
    if(this.centralPedidosEstaDesligada())
      return false;

    return this.tocarAlerta || this.modoGrupoLojas;

  }

  altereNotificacoesCentralPedidosDesligadas(desligadas: boolean) {
    this.notificacoesCentralPedidosDesligadas = !!desligadas;
    this.armazenamentoService.salveSemExpirar(
      this.KEYNOTIFICACOESCENTRALPEDIDOSDESLIGADAS,
      this.notificacoesCentralPedidosDesligadas ? '1' : '0'
    );

    if(!this.modoGrupoLojas) return;

    if(this.notificacoesCentralPedidosDesligadas) {
      this.pareMonitoramento();
      this.pareMonitoramentoIntegracoes();
      this.pareAlerta();
      this.fecheModalAlerta();
      this.limpePedidosMonitorados();
      return;
    }

    this.inicieMonitoramento();
  }

  inIframe () {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  getService() {
    if (this.modoGrupoLojas)
      return this.grupolojasService;

    return this.pedidosService;
  }

  async carregueConfigsImpressaoGrupoLojas(){
    if(!this.modoGrupoLojas)
      return this.configImpressaoPorEmpresaId;

    if(this.configsImpressaoGrupoLojasCarregadas)
      return this.configImpressaoPorEmpresaId;

    if(this.carregandoConfigsImpressaoGrupoLojas)
      return this.carregandoConfigsImpressaoGrupoLojas;

    this.carregandoConfigsImpressaoGrupoLojas = this.grupolojasService.obtenhaCentralPedidos()
      .then((contexto: any) => {
        this.configImpressaoPorEmpresaId = {};

        (contexto?.lojas || []).forEach((loja: any) => {
          if(loja?.id && loja.configImpressao)
            this.configImpressaoPorEmpresaId[Number(loja.id)] = loja.configImpressao;
        });

        this.configsImpressaoGrupoLojasCarregadas = true;

        return this.configImpressaoPorEmpresaId;
      })
      .catch((erro: any) => {
        console.error(erro);
        return this.configImpressaoPorEmpresaId;
      });

    const configs = await this.carregandoConfigsImpressaoGrupoLojas;
    this.carregandoConfigsImpressaoGrupoLojas = null;

    return configs;
  }

  obtenhaConfigImpressaoEmpresaGrupo(empresaId: any){
    if(!empresaId) return null;

    return this.configImpressaoPorEmpresaId[Number(empresaId)] || null;
  }

  apliqueConfigsImpressaoGrupoPedidos(pedidos: any[] = []){
    if(!this.modoGrupoLojas) return pedidos;

    (pedidos || []).forEach((pedido: any) => {
      const empresaId = pedido?.empresa?.id;
      const configImpressao = this.obtenhaConfigImpressaoEmpresaGrupo(empresaId);

      if(configImpressao)
        pedido.empresa.configImpressao = configImpressao;
    });

    return pedidos;
  }

  private inicieMonitoramentoLojasIfood(){
    if(!this.timerLoja){
      this.timerLoja =  timer(0, 1000 * segundosTimer  ).subscribe( () => {
        this.autalizeStatusIfood()
      });
    }
  }

  private inicieMonitoramentoLojas99Food(){
    if(!this.timerLoja99){
      //5min pq 99 bloqueia se fizer mais de 1 chamada por 1 min
      this.timerLoja99 =  timer(0, 1000 * (60 * 5)  ).subscribe( () => {
        this.autalizeStatus99Food();
      });
    }
  }

  private inicieMonitoramentoLojasKeeta(){
    if(!this.timerLojaKeeta){
      this.timerLojaKeeta =  timer(0, 1000 * segundosTimer  ).subscribe( () => {
        this.autalizeStatusKeeta()
      });
    }
  }

  private async inicieMonitoramentoPedidos() {
    if(this.centralPedidosEstaDesligada()) return;

    console.log('iniciando monitoramento pedidos novos')
    this.configurarOrigens();

    let resposta: any = await this.getService().listeUltimoPedidosAtras(segundosTimer    , this.origens);

    if(this.centralPedidosEstaDesligada()) return;

    if(resposta){
      this.ultimoPedido = resposta.ultimo;
      this.pedidosMonitorarPagamento = resposta.pedidosMonitorarPagamento || [];
      this.resumoMesas.next( resposta.resumoMesas )
      await this.inicieMonitoramentoErroIntegracao();
      if(!this.timerPedidos){
        this.timerPedidos =  timer(2000, 1000 * segundosTimer  ).subscribe( () => {
          this.carregueNovosPedidos()
        });
      }
    } else {
      console.warn('nao foi possivel obter informaçoes do ultimo pedido')
    }
  }


  private async monitorarNFCeAutorizadas() {
    if(!this.deveMonitorarNFCeAutorizadas()) {
      this.pareMonitoramentoNFCe();
      return;
    }

    console.log('Iniciando monitoramento de NFCe autorizadas');

    console.log('Empresa', this.empresa)
    if (!this.timerNFCe) {
      console.log('Timer de NFCe não existe, criando novo timer');
      this.timerNFCe = timer(0, 1000 * segundosTimer).subscribe(async () => {
        if(!this.deveMonitorarNFCeAutorizadas() || this.carregandoNFCe)
          return;

        console.log('Executando verificação de NFCe autorizadas: ' + new Date().toLocaleString());
        try {
          this.carregandoNFCe = true;
          //o horário é a última vez que consultou as nfces autorizadas, não tem relação com o horário do pedido
          console.log('Solicitando NFCes autorizadas ao serviço');
          const resposta = await this.nfeService.obtenhaProximasParaImpressao();
          const nfcesAutorizadas = resposta.nfces

          if (nfcesAutorizadas && nfcesAutorizadas.length > 0) {
            console.log(`${nfcesAutorizadas.length} NFCe(s) autorizadas para impressão encontradas`);


            // Aqui você pode adicionar lógica para impressão automática se necessário
            if (this.deveMonitorarNFCeAutorizadas()) {
              console.log('Condições para impressão automática atendidas, iniciando impressão');
              await this.imprimaNfces(nfcesAutorizadas);
              console.log('Impressão de NFCes concluída');
            } else {
              console.log('Impressão automática não realizada devido às configurações atuais');
            }
          } else {
            console.log('Nenhuma NFCe autorizada encontrada para impressão');
          }
        } catch (erro) {
          console.error('Erro ao monitorar NFCe autorizadas:', erro);
          console.log('Detalhes do erro:', JSON.stringify(erro));
        } finally {
          this.carregandoNFCe = false;
        }
      });
    } else {
      console.log('Timer de NFCe já existe, mantendo o atual');
    }
  }

  private configureMonitoramentoNFCe() {
    if(!this.moduloFiscalSubscription) {
      this.moduloFiscalSubscription = this.constantsService.moduloFiscal$.subscribe({
        next: (data) => {
          this.temModuloFiscal = !!data;
          this.atualizeMonitoramentoNFCe();
        }
      });
    }

    if(!this.impressaoAutomaticaNfceSubscription) {
      this.impressaoAutomaticaNfceSubscription = this.constantsService.impressaoAutomaticaNfce$.subscribe({
        next: (data) => {
          this.imprimirNfceAutomaticamente = !!data;
          this.atualizeMonitoramentoNFCe();
        }
      });
    }
  }

  private atualizeMonitoramentoNFCe() {
    if(this.deveMonitorarNFCeAutorizadas())
      this.monitorarNFCeAutorizadas();
    else
      this.pareMonitoramentoNFCe();
  }

  private devePermitirMonitoramentoNFCe() {
    return this.temModuloFiscal && this.imprimirNfceAutomaticamente;
  }

  private deveMonitorarNFCeAutorizadas() {
    if(!this.podeContinuarImpressaoAutomatica())
      return false;

    if(!this.devePermitirMonitoramentoNFCe() || this.inIframe() || this.isMobile || this.constantsService.naoImprimir)
      return false;

    if(!this.empresa?.configImpressao?.imprimirTXT)
      return false;

    const impressoras = this.empresa.configImpressao.impressoras || [];
    return impressoras.some((impressora: any) => impressora && !impressora.removida && impressora.imprimirNFCe);
  }

  private pareMonitoramentoNFCe() {
    if(this.timerNFCe)
      this.timerNFCe.unsubscribe();

    this.timerNFCe = null;
    this.carregandoNFCe = false;
  }

  private notificarNFCeAutorizadas(nfces: any[]) {
    if (nfces && nfces.length > 0 && this.tocarAlerta) {
      // Tocar alerta para novas NFCe autorizadas
      this.toqueAlerta();

      // Adicionar notificação ou atualizar interface
      // Você pode implementar um sistema similar ao de novos pedidos
    }
  }


  private configurarOrigens() {
    this.origens = [EnumOrigemPedido.Loja, EnumOrigemPedido.Ifood,  EnumOrigemPedido.Keeta, EnumOrigemPedido.Food99];

    if (this.empresa?.darkPrincipal)
      this.origens.push(EnumOrigemPedido.Multiloja)

    if (!this.constantsService.naoTocarGarcom)
      this.origens.push(EnumOrigemPedido.Garcom)
  }

  atualizeFoiLido(pedido){
    let pedidoLido = this.novosPedidos.find( pedidoNovo => pedidoNovo.id === pedido.id);

    if(pedidoLido)
      this.novosPedidos.splice( this.novosPedidos.indexOf(pedidoLido), 1);

  }

  fecheEZerePedidosNovos(){



    this.novosPedidos = [];
    this.pedidosConfirmados = [];
    this.pedidosCanceladosCliente = [];

    this.pedidosEnderecoAlterado = [];
    this.pedidosErroIntegracao = [];
    this.avisos = [];

    if(this.modoGrupoLojas) {
      this.falhasImportacao = [];
    }

    this.pedidosContestados.forEach((pedido) => {
      this.pedidosContestadosVisualizados[pedido.id] = pedido;
    })

    this.pedidosContestados = [];

    this.fecheModalAlerta();
  }

  carregueNovosPedidos(){
   if(this.centralPedidosEstaDesligada()) return;

   // console.log ("Carregando novos pedidos " + new Date())
    let filtro: any = { emAberto: true, origens: this.origens, ultimoPedido: this.ultimoPedido ? this.ultimoPedido.id : null
    , avisos: true
    }

    if(!this.servidorImpresaoExecutor.ehUmServidorAtivo()){
      if(!this.inIframe() && !this.isMobile && !this.constantsService.naoImprimir)
      {
        if(this.modoGrupoLojas ||
          (this.empresa?.configImpressao && this.empresa.configImpressao.momentoImprimirAuto === EnumMomentoImprimirAuto.NovoPedido))
          filtro.naoImpressos = true

      } else
        console.log("Impressão automática desativada. Não carregará pedidos não impressos")
    }

    if(this.pedidosMonitorarPagamento.length)
      filtro.onlineAguardando = this.pedidosMonitorarPagamento

    if( this.carregandoNovos) return;

    let service: any =  this.getService();

    this.carregandoNovos = true;

    service.listePedidos(0, 100, filtro, EnumFiltroDePedidos.todos).then( async (resposta) => {
      this.carregandoNovos = false;
      if(this.centralPedidosEstaDesligada()) return;

      let novosPedidos = resposta ? resposta.pedidos || [] : [];
      let pedidosPagos = resposta ? resposta.pedidosPagos || [] : [];
      let contestados = resposta ? resposta.contestados || [] : [];
      let pedidosEnderecoAlterado = resposta ? resposta.pedidosEnderecoAlterado || [] : [];
      let falhasNaImportacao = resposta ? resposta.falhasNaImportacao || [] : [];
      let tocarAlterta = false;

      this.avisos = resposta ? resposta.avisos || [] : [];
      this.removaChargebacksCellcoinSemAcao(contestados);

      if(this.modoGrupoLojas) {
        await this.carregueConfigsImpressaoGrupoLojas();

        if(this.centralPedidosEstaDesligada()) return;

        this.apliqueConfigsImpressaoGrupoPedidos(novosPedidos);
        this.apliqueConfigsImpressaoGrupoPedidos(pedidosPagos);
        this.apliqueConfigsImpressaoGrupoPedidos(contestados);
        this.apliqueConfigsImpressaoGrupoPedidos(pedidosEnderecoAlterado);
        this.apliqueConfigsImpressaoGrupoPedidos(resposta?.naoImpressos || []);
      }

      novosPedidos.forEach((pedido: any) => {
        if(this.chegouNovoPedido(pedido))
          tocarAlterta = true;
      });

      pedidosPagos.forEach((pedido: any) => {
        if(this.pagouPedidoAguardando(pedido))
          tocarAlterta = true;
      });

      contestados.forEach((pedido: any) => {
        if(this.chegouNovoPedidoContestado(pedido))
          tocarAlterta = true;
      })

      if(this.modoGrupoLojas) {
        pedidosEnderecoAlterado.forEach((pedido: any) => {
          if(this.chegouPedidoEnderecoAlterado(pedido))
            tocarAlterta = true;
        })
      }

      if(this.modoGrupoLojas) {
        falhasNaImportacao.forEach((falhaImportacao: any) => {
          if(this.novoPedidoNoImportado(falhaImportacao))
            tocarAlterta = true;
        })
      }

      if(await this.carregueNovosPedidosErroIntegracao())
        tocarAlterta = true;

      if(this.centralPedidosEstaDesligada()) return;

      if(this.avisos.length >= 1)
        tocarAlterta = true;

      if(tocarAlterta && this.tocarAlerta)
        this.inicieAlerta();

      if(this.modoGrupoLojas)
        this.pedidosGrupoAtualizados.next(resposta || {});

      if(resposta && resposta.naoImpressos && resposta.naoImpressos.length)
        await this.imprimaNovosPedidos(resposta.naoImpressos);

    }).catch( (err: any) => {
      console.error(err)
      this.carregandoNovos = false;
    });
  }

  pagouPedidoAguardando(pedido: any){
    //as vezes sever cai, pode encavalar request.
    let pedidoExistente =  this.pedidosConfirmados.find((item: any) => item.id === pedido.id);

    if(pedidoExistente) return false;

    this.pedidosConfirmados.push(pedido);

    let iremover = this.pedidosMonitorarPagamento.indexOf(pedido.id);

    if(iremover >= 0)
      this.pedidosMonitorarPagamento.splice(iremover, 1);

    return true;

  }

  chegouCancelamentoPedidoCliente(pedido: any){
    let pedidoExistente = this.pedidosCanceladosCliente.find((item: any) => item.id === pedido.id);

    if(pedidoExistente) return false;

    this.pedidosCanceladosCliente.push(pedido);

    return true;
  }


  novoPedidoNoImportado(falhaImportacao: any){
    let falhaExistente = this.falhasImportacao.find((item: any) => item.id === falhaImportacao.id);

    if(falhaExistente) return false;

    this.falhasImportacao.push(falhaImportacao)

    return true;
  }

  private deveMonitorarErroIntegracao(){
    return this.empresa && this.empresa.integracaoDelivery && !this.modoGrupoLojas;
  }

  private async inicieMonitoramentoErroIntegracao(){
    if(!this.deveMonitorarErroIntegracao() || this.monitoramentoErroIntegracaoIniciado)
      return;

    try{
      let pedidos = await this.pedidosService.listeIntegradosComErro(0, 100, {});

      (pedidos || []).forEach((pedido: any) => {
        this.errosIntegracaoConhecidos[pedido.id] = true;
        this.atualizeUltimaAtualizacaoErroIntegracao(pedido);
      })

      if(!this.ultimaAtualizacaoErroIntegracao)
        this.ultimaAtualizacaoErroIntegracao = moment().format('YYYYMMDDHHmmss');

      this.monitoramentoErroIntegracaoIniciado = true;
    } catch (err) {
      console.error(err);
    }
  }

  private async carregueNovosPedidosErroIntegracao(){
    if(!this.deveMonitorarErroIntegracao())
      return false;

    if(!this.monitoramentoErroIntegracaoIniciado){
      await this.inicieMonitoramentoErroIntegracao();
      return false;
    }

    let filtro: any = {};

    if(this.ultimaAtualizacaoErroIntegracao)
      filtro.ultimaAtualizacao = moment(this.ultimaAtualizacaoErroIntegracao, 'YYYYMMDDHHmmss')
        .add(-2, 'minutes')
        .format('YYYYMMDDHHmmss');

    try{
      let pedidos = await this.pedidosService.listeIntegradosComErro(0, 100, filtro);
      let tocarAlterta = false;

      pedidos = (pedidos || []).sort((pedidoA: any, pedidoB: any) => {
        return moment(pedidoA.horarioAtualizacao).valueOf() - moment(pedidoB.horarioAtualizacao).valueOf();
      })

      pedidos.forEach((pedido: any) => {
        this.atualizeUltimaAtualizacaoErroIntegracao(pedido);

        if(this.chegouPedidoErroIntegracao(pedido))
          tocarAlterta = true;
      })

      return tocarAlterta;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  private atualizeUltimaAtualizacaoErroIntegracao(pedido: any){
    if(!pedido || !pedido.horarioAtualizacao)
      return;

    let ultimaAtualizacao = moment(pedido.horarioAtualizacao).format('YYYYMMDDHHmmss');

    if(!this.ultimaAtualizacaoErroIntegracao || ultimaAtualizacao > this.ultimaAtualizacaoErroIntegracao)
      this.ultimaAtualizacaoErroIntegracao = ultimaAtualizacao;
  }

  chegouPedidoErroIntegracao(pedido: any){
    if(this.errosIntegracaoConhecidos[pedido.id])
      return false;

    this.errosIntegracaoConhecidos[pedido.id] = true;
    this.pedidosErroIntegracao.push(pedido);

    return true;
  }

  chegouNovoPedidoContestado(pedido: any){
    let pedidoExistente =  this.pedidosContestados.find((item: any) => item.id === pedido.id);

    if(pedidoExistente || this.pedidosContestadosVisualizados[pedido.id] != null)
      return false;

    this.pedidosContestados.push(pedido);

    return true;
  }

  private removaChargebacksCellcoinSemAcao(contestados: Array<any>){
    const idsAtivos = (contestados || []).map((pedido: any) => String(pedido.id));
    const totalAnterior = this.pedidosContestados.length;

    this.pedidosContestados = this.pedidosContestados.filter((pedido: any) =>
      !pedido?.disputa?.cellcoinChargeback || idsAtivos.indexOf(String(pedido.id)) >= 0
    );

    if(totalAnterior !== this.pedidosContestados.length && !this.temAvisosPedidos() &&
      !this.pedidosConfirmados.length && !this.avisos.length)
      this.fecheModalAlerta();
  }

  chegouPedidoEnderecoAlterado(pedido: any){
    let pedidoExistente =  this.pedidosEnderecoAlterado.find((item: any) => item.id === pedido.id);

    if(pedidoExistente) return false;

    this.pedidosEnderecoAlterado.push(pedido);

    return true;
  }

  chegouNovoPedido(pedido: any){
    //as vezes sever cai, pode encavalar request.
    let pedidoExistente =  this.novosPedidos.find((item: any) => item.id === pedido.id);

    if(pedidoExistente) return false;

    if(!this.ultimoPedido  || this.ultimoPedido.id < pedido.id)
      this.ultimoPedido = pedido;

    if(pedido.mesa){
      this.resumoMesas.value.totalNovo++
      let resumoMesa = this.resumoMesas.value.mesas.find( mesa => mesa.id === pedido.mesa.id);

      if(!resumoMesa){
        resumoMesa = { totalNovo: 0, mesa: pedido.mesa.nome }
        this.resumoMesas.value.mesas.push(resumoMesa)
      }

      resumoMesa.totalNovo++;
      this.resumoMesas.next(this.resumoMesas.value)
    }

    if(pedido.monitorarConfirmacaoPagamento)
      if(this.pedidosMonitorarPagamento.indexOf(pedido.id) === - 1)
        this.pedidosMonitorarPagamento.push(pedido.id)


    if(pedido.notificarNovo){
      this.novosPedidos.push(pedido);
      this.pedidos.push(pedido);
    }

    return pedido.notificarNovo;
  }

  zereComadasNaoLidas(comanda: any = null){
    this.resumoMesas.value.mesas.forEach((resumoMesa: any) => {
      if(!comanda || comanda.mesa.id === resumoMesa.id){
        if(comanda)
          this.resumoMesas.value.totalNovo -=  resumoMesa.totalNovo;
        else
          this.resumoMesas.value.totalNovo = 0;

        resumoMesa.totalNovo = 0;
      }
    })

    this.resumoMesas.next(this.resumoMesas.value)
  }

  alterouStatusPedido(pedido: any){

    if(pedido.mesa){
      let resumoMesa = this.resumoMesas.value.mesas.find( mesa => mesa.id === pedido.mesa.id);

      if(resumoMesa)   resumoMesa.totalNovo--;

      this.resumoMesas.value.totalNovo--;
    }
  }

  inicieAlerta(){

    if(!this.tocarAlerta) return;

    this.toquesRestantesAlerta = this.quantidadeToquesAlerta;

    if( this.tarefaAlerta) return;

    $("#alertaNovo").modal();

    $("#alertaNovo").on("hidden.bs.modal",   () => {
      this.pareAlerta();
    });

    this.tarefaAlerta = fromEvent(this.beep, 'ended').subscribe(() => {
      if(this.quantidadeToquesAlerta > 0){
        this.toquesRestantesAlerta--;

        console.log('[ALERTA PEDIDOS] toque finalizado', {
          quantidadeConfigurada: this.quantidadeToquesAlerta,
          toquesRestantes: this.toquesRestantesAlerta
        });

        if(this.toquesRestantesAlerta <= 0){
          this.pareRepeticaoAlerta();
          return;
        }
      }

      this.toqueAlerta();
    });

    this.toqueAlerta();
  }

  altereQuantidadeToquesAlerta(quantidade: number){
    this.quantidadeToquesAlerta = Number(quantidade);
    this.toquesRestantesAlerta = this.quantidadeToquesAlerta;
    this.armazenamentoService.salveSemExpirar(
      this.KEYQUANTIDADETOQUESALERTA,
      String(this.quantidadeToquesAlerta)
    );
  }

  pareAlerta(){
    if(this.beep) {
      this.beep.pause();
      this.beep.currentTime = 0;
    }

    this.pareRepeticaoAlerta();
    // window.scrollTo(0, document.body.scrollHeight);
  }

  private pareRepeticaoAlerta(){
    if(this.tarefaAlerta)
      this.tarefaAlerta.unsubscribe();

    delete this.tarefaAlerta;
    this.toquesRestantesAlerta = 0;
  }

  toqueAlerta(){
    console.log('[ALERTA PEDIDOS] reproduzindo toque', {
      quantidadeConfigurada: this.quantidadeToquesAlerta,
      toquesRestantes: this.toquesRestantesAlerta
    });

    this.beep.play().then( () => {
    }).catch (e => {
      console.log('nao tocou alerta: ')
      console.log(e)
    });

  }

  fecheModalAlerta(){
    $("#alertaNovo").modal('hide');
  }

  pareMonitoramento() {
    if(this.timerPedidos) {
      this.timerPedidos.unsubscribe();
      this.timerPedidos = null;
    }

    this.pareMonitoramentoNFCe();
  }

  private pareMonitoramentoIntegracoes() {
    if(this.timerLoja)
      this.timerLoja.unsubscribe();

    if(this.timerLoja99)
      this.timerLoja99.unsubscribe();

    if(this.timerLojaKeeta)
      this.timerLojaKeeta.unsubscribe();

    this.timerLoja = null;
    this.timerLoja99 = null;
    this.timerLojaKeeta = null;
  }

  private limpeDadosGrupoLojas() {
    this.lojasIfood = [];
    this.lojasKeeta = [];
    this.lojas99Food = [];
    this.configImpressaoPorEmpresaId = {};
    this.carregandoConfigsImpressaoGrupoLojas = null;
    this.configsImpressaoGrupoLojasCarregadas = false;
    this.pedidosEnderecoAlterado = [];
    this.falhasImportacao = [];
    this.avisos = [];
  }

  private limpePedidosMonitorados() {
    this.novosPedidos = [];
    this.pedidosConfirmados = [];
    this.pedidosCanceladosCliente = [];
    this.pedidosContestados = [];
    this.pedidosContestadosVisualizados = {};
    this.pedidosEnderecoAlterado = [];
    this.pedidosErroIntegracao = [];
    this.falhasImportacao = [];
    this.avisos = [];
    this.pedidosMonitorarPagamento = [];
    this.ultimoPedido = null;
  }

  protected marqueFoiImpresso(pedido: any, impressoPeloMonitorador = false, impressora: any = null) {
    if(this.modoGrupoLojas)
      return this.grupolojasService.marqueFoiImpresso(pedido, null, impressoPeloMonitorador, impressora);

    return super.marqueFoiImpresso(pedido, impressoPeloMonitorador, impressora);
  }

  protected podeContinuarImpressaoAutomatica() {
    return !this.centralPedidosEstaDesligada();
  }

  protected deveUsarEmpresaDoPedidoParaImpressao() {
    return this.modoGrupoLojas;
  }

  private centralPedidosEstaDesligada() {
    return this.modoGrupoLojas && this.notificacoesCentralPedidosDesligadas;
  }

  notifiqueResumo(pedidos: any, contestados: any, falhasImportacao: any){
    let pedidosErro = pedidos.filter((pedido: any) => pedido.erroExterno && pedido.naoNotificado);
    let pedidosOnlineAguardando = pedidos.filter((pedido: any) => pedido.aguardandoPagamentoOnline);

    this.resumoPedidos.next({
      totalPendenteOnline: pedidosOnlineAguardando.length,
      totalErroParceiro: pedidosErro.length,
      totalContestados: contestados.length,
      totalErrosImportar: falhasImportacao.length,
      totalErroParceiroMesa: 0,
    });
  }

  notifiqueMesasComErro(totalErroParceiroMesa: number){
    this.mesasComErros.next({
      totalErroParceiroMesa : totalErroParceiroMesa
    })
  }

  notifiqueEstoqueAlertas(totalAlertas: number){
    this.resumoEstoque.next( { totalAlertas: totalAlertas})
  }

  verPedido(pedido: any) {
    this.fecheEZerePedidosNovos();
    if(this.modoGrupoLojas && pedido?.empresa?.id) {
      this.router.navigateByUrl(String(`/admin-grupo/pedidos/detalhes/${pedido.empresa.id}/${pedido.guid}`), { state: pedido });
      return;
    }

    this.router.navigateByUrl(  String(`/admin/pedidos/detalhes/${pedido.guid}?t=${pedido.id}`), { state: pedido });

  }

  totalPedidosMonitorados(){
    const totalLoja = this.novosPedidos.length + this.pedidosConfirmados.length + this.pedidosCanceladosCliente.length;

    if(!this.modoGrupoLojas)
      return totalLoja;

    return totalLoja + this.pedidosContestados.length + this.pedidosEnderecoAlterado.length + this.pedidosErroIntegracao.length
      + this.falhasImportacao.length + (this.avisos ? this.avisos.length : 0);
  }

  toogleNaoImprimir() {
    this.constantsService.toogleNaoImprimir();

  }

  toogleNaoTocarGarcom() {
    this.constantsService.toogleNaoTocarGarcom();
    this.configurarOrigens();
  }

  temAvisosPedidos(){
    return this.novosPedidos.length   || this.pedidosContestados.length
    || this.pedidosEnderecoAlterado.length || this.pedidosErroIntegracao.length || this.pedidosCanceladosCliente.length;
  }

  executandoServidorImpressao(){
    return this.servidorImpresaoExecutor.executando;
  }


}
